import ArchbishopWilliams from '../../assets/schools/main/archbishop-williams.jpg';
import ArlingtonCatholic from '../../assets/schools/main/artlington.jpg';
import AustinPrep from '../../assets/schools/main/austin.jpg';
import BCHigh from '../../assets/schools/main/bc.jpg';
import BishopFenwick from '../../assets/schools/main/bfenwick.jpg';
import CardinalSpellman from '../../assets/schools/main/cardspell.jpg';
import CathedralHigh from '../../assets/schools/main/cathedral.jpg';
import CatholicMemorial from '../../assets/schools/main/cath_mem.jpg';
import CentralCatholic from '../../assets/schools/main/centcath.jpg';
import CristoRey from '../../assets/schools/main/cristo-rey.jpg';
import Default from '../../assets/schools/main/default.jpg';
import FontbonneAcademy from '../../assets/schools/main/font.jpg';
import LowellCatholic from '../../assets/schools/main/lowell.jpg';
import MaldenCatholic from '../../assets/schools/main/malden.jpg';
import Matignon from '../../assets/schools/main/matignon.jpg';
import MtAlvernia from '../../assets/schools/main/mt_alvernia.jpg';
import NewtonCountryDay from '../../assets/schools/main/newton-country-day.jpg';
import NotreDameCristoRey from '../../assets/schools/main/notre-dame-cristo-rey.jpg';
import NotreDameHingham from '../../assets/schools/main/nd.jpg';
import NotreDameTyngsboro from '../../assets/schools/main/notre-dame-tyngsboro.jpg';
import PopeJohn from '../../assets/schools/main/pjxxiii.jpg';
import MaryAcademy from '../../assets/schools/main/pres.jpg';
import SacredHeart from '../../assets/schools/main/sacred_h.jpg';
import StJohnsPrep from '../../assets/schools/main/st-johns-prep.jpg';
import StJoseph from '../../assets/schools/main/stjoe.jpg';
import StMary from '../../assets/schools/main/wfc_center.jpg';
import StSebas from '../../assets/schools/main/st-sebas.jpg';
import UrsulineAcademy from '../../assets/schools/main/ursuline-academy.jpg';
import XaverianBrothers from '../../assets/schools/main/xaverian-brothers.jpg';
import BellesiniAcademy from "../../assets/schools/main/BellesiniAcademy.jpg";
import BlessedSacramentSchool from "../../assets/schools/main/BlessedSacramentSchool.jpg";
import CheverusCatholicSchool from "../../assets/schools/main/CheverusCatholicSchool.jpg";
import EastBostonCentral from "../../assets/schools/main/EastBostonCentral.jpg";
import HolyNameParish from "../../assets/schools/main/HolyNameParish.jpg";
import ImmaculateConceptionLowell from "../../assets/schools/main/ImmaculateConceptionLowell.jpg";
import ImmaculateConceptionNewburyport from "../../assets/schools/main/ImmaculateConceptionNewburyport.jpg";
import ImmaculateConceptionRevere from "../../assets/schools/main/ImmaculateConceptionRevere.jpg";
import JacksonWalnutPark from "../../assets/schools/main/JacksonWalnutPark.jpg";
import LawrenceCatholicAcademy from "../../assets/schools/main/LawrenceCatholicAcademy.jpg";
import MotherCarolineAcademy from "../../assets/schools/main/MotherCarolineAcademy.jpg";
import MountAlverniaAcademy from "../../assets/schools/main/MountAlverniaAcademy.jpg";
import NativityPreparatorySchool from "../../assets/schools/main/NativityPreparatorySchool.jpg";
import NotreDameAcademy from "../../assets/schools/main/NotreDameAcademy.jpg";
import OurLadysAcademy from "../../assets/schools/main/OurLadysAcademy.jpg";
import OurLadyPerpetualHelp from "../../assets/schools/main/OurLadyPerpetualHelp.jpg";
import OurLadyAssumption from "../../assets/schools/main/OurLadyAssumption.jpg";
import QuincyCatholicAcademy from "../../assets/schools/main/QuincyCatholicAcademy.jpg";
import SacredHeartKingston from "../../assets/schools/main/SacredHeartKingston.jpg";
import SacredHeartLynn from "../../assets/schools/main/SacredHeartLynn.jpg";
import SacredHeartSchoolRoslindale from "../../assets/schools/main/SacredHeartSchoolRoslindale.jpg";
import SacredHeartSchoolWeymouth from "../../assets/schools/main/SacredHeartSchoolWeymouth.jpg";
import SacredHeartSchoolHaverhill from "../../assets/schools/main/SacredHeartSchoolHaverhill.jpg";
import SouthBostonCatholicAcademy from "../../assets/schools/main/SouthBostonCatholicAcademy.jpg";
import SaintAgathaSchool from "../../assets/schools/main/SaintAgathaSchool.jpeg";
import SaintAgnesSchool from "../../assets/schools/main/SaintAgnesSchool.jpg";
import SaintAnthonySchool from "../../assets/schools/main/SaintAnthonySchool.png";
import SaintAugustineSchool from "../../assets/schools/main/SaintAugustineSchool.jpg";
import SaintBenedictElementarySchool from "../../assets/schools/main/SaintBenedictElementarySchool.jpg";
import SaintBrendanSchool from "../../assets/schools/main/SaintBrendanSchool.jpg";
import SaintBridgetSchoolAbington from "../../assets/schools/main/SaintBridgetSchoolAbington.jpg";
import SaintBridgetSchoolFramingham from "../../assets/schools/main/SaintBridgetSchoolFramingham.jpg";
import SaintCatherineofSienaSchool from "../../assets/schools/main/SaintCatherineofSienaSchool.jpg";
import SaintColumbkillePartnership from "../../assets/schools/main/SaintColumbkillePartnership.jpg";
import SaintCharlesElementarySchool from "../../assets/schools/main/SaintCharlesElementarySchool.jpeg";
import SaintFrancisXavierSchool from "../../assets/schools/main/SaintFrancisXavierSchool.jpg";
import StJohnsPreparatorySchool from "../../assets/schools/main/StJohnsPreparatorySchool.jpg";
import StJohnPaulCatholicAcademyColumbia from "../../assets/schools/main/StJohnPaulCatholicAcademyColumbia.jpg";
import StJohnPaulCatholicAcademyLowerMills from "../../assets/schools/main/StJohnPaulCatholicAcademyLowerMills.jpg";
import StJohnPaulCatholicAcademyNeponset from "../../assets/schools/main/StJohnPaulCatholicAcademyNeponset.jpg";
import SaintJohntheBaptistSchool from "../../assets/schools/main/SaintJohntheBaptistSchool.jpg";
import SaintJohntheEvangelistSchoolWellesley from "../../assets/schools/main/SaintJohntheEvangelistSchoolWellesley.jpg";
import SaintJohntheEvangelistSchoolDanvers from "../../assets/schools/main/SaintJohntheEvangelistSchoolDanvers.jpg";
import SaintJosephElementarySchoolMedford from "../../assets/schools/main/SaintJosephElementarySchoolMedford.jpg";
import SaintJosephElementarySchoolWakefield from "../../assets/schools/main/SaintJosephElementarySchoolWakefield.jpg";
import StJosephNeedham from "../../assets/schools/main/StJosephNeedham.jpg";
import SaintMaryoftheAnnunciationSchool from "../../assets/schools/main/SaintMaryoftheAnnunciationSchool.jpg";
import SaintMaryoftheAnnunciationSchoolDanvers from "../../assets/schools/main/SaintMaryoftheAnnunciationSchoolDanvers.png";
import SaintMaryoftheAnnunciationSchoolMelrose from "../../assets/schools/main/SaintMaryoftheAnnunciationSchoolMelrose.jpg";
import SaintMaryoftheHillsSchool from "../../assets/schools/main/SaintMaryoftheHillsSchool.jpg";
import StMichaelLowell from "../../assets/schools/main/StMichaelLowell.jpg";
import StMichaelNorthAndover from "../../assets/schools/main/StMichaelNorthAndover.jpg";
import SaintMonicaSchool from "../../assets/schools/main/SaintMonicaSchool.jpg";
import SaintPatrickSchoolLowell from "../../assets/schools/main/SaintPatrickSchoolLowell.jpg";
import StPatrickStoneham from "../../assets/schools/main/StPatrickStoneham.jpg";
import SaintPaulSchool from "../../assets/schools/main/SaintPaulSchool.jpg";
import SaintPaulsChoirSchool from "../../assets/schools/main/SaintPaulsChoirSchool.jpg";
import SaintPeterSchool from "../../assets/schools/main/SaintPeterSchool.jpg";
import SaintPiusVElementarySchool from "../../assets/schools/main/SaintPiusVElementarySchool.jpg";
import SaintRaphaelParishSchool from "../../assets/schools/main/SaintRaphaelParishSchool.jpg";
import SaintTheresaCatholicSomerville from "../../assets/schools/main/SaintTheresaCatholicSomerville.jpg";
import SaintTheresaofAvilaWestRoxbury from "../../assets/schools/main/SaintTheresaofAvilaWestRoxbury.png";
import SteJeannedArcSchool from "../../assets/schools/main/SteJeannedArcSchool.jpg";
import TheSaintsAcademy from "../../assets/schools/main/TheSaintsAcademy.jpg";
import TrinityCatholicAcademy from "../../assets/schools/main/TrinityCatholicAcademy.jpg";

const images = {
  ArchbishopWilliams: ArchbishopWilliams,
  ArlingtonCatholic: ArlingtonCatholic,
  AustinPrep: AustinPrep,
  BCHigh: BCHigh,
  BishopFenwick: BishopFenwick,
  CardinalSpellman: CardinalSpellman,
  CathedralHigh: CathedralHigh,
  CatholicMemorial: CatholicMemorial,
  CentralCatholic: CentralCatholic,
  CristoRey: CristoRey,
  Default: Default,
  FontbonneAcademy: FontbonneAcademy,
  LowellCatholic: LowellCatholic,
  MaldenCatholic: MaldenCatholic,
  Matignon: Matignon,
  MtAlvernia: MtAlvernia,
  NewtonCountryDay: NewtonCountryDay,
  NotreDameCristoRey: NotreDameCristoRey,
  NotreDameHingham: NotreDameHingham,
  NotreDameTyngsboro: NotreDameTyngsboro,
  PopeJohn: PopeJohn,
  MaryAcademy: MaryAcademy,
  SacredHeart: SacredHeart,
  StJohnsPrep: StJohnsPrep,
  StJoseph: StJoseph,
  StMary: StMary,
  StSebas: StSebas,
  UrsulineAcademy: UrsulineAcademy,
  XaverianBrothers: XaverianBrothers,
  BellesiniAcademy: BellesiniAcademy,
  BlessedSacramentSchool: BlessedSacramentSchool,
  CheverusCatholicSchool: CheverusCatholicSchool,
  EastBostonCentral: EastBostonCentral,
  HolyNameParish: HolyNameParish,
  ImmaculateConceptionLowell: ImmaculateConceptionLowell,
  ImmaculateConceptionNewburyport: ImmaculateConceptionNewburyport,
  ImmaculateConceptionRevere: ImmaculateConceptionRevere,
  JacksonWalnutPark: JacksonWalnutPark,
  LawrenceCatholicAcademy: LawrenceCatholicAcademy,
  MotherCarolineAcademy: MotherCarolineAcademy,
  MountAlverniaAcademy: MountAlverniaAcademy,
  NativityPreparatorySchool: NativityPreparatorySchool,
  NotreDameAcademy: NotreDameAcademy,
  OurLadysAcademy: OurLadysAcademy,
  OurLadyPerpetualHelp: OurLadyPerpetualHelp,
  OurLadyAssumption: OurLadyAssumption,
  QuincyCatholicAcademy: QuincyCatholicAcademy,
  SacredHeartKingston: SacredHeartKingston,
  SacredHeartLynn: SacredHeartLynn,
  SacredHeartSchoolRoslindale: SacredHeartSchoolRoslindale,
  SacredHeartSchoolWeymouth: SacredHeartSchoolWeymouth,
  SacredHeartSchoolHaverhill: SacredHeartSchoolHaverhill,
  SouthBostonCatholicAcademy: SouthBostonCatholicAcademy,
  SaintAgathaSchool: SaintAgathaSchool,
  SaintAgnesSchool: SaintAgnesSchool,
  SaintAnthonySchool: SaintAnthonySchool,
  SaintAugustineSchool: SaintAugustineSchool,
  SaintBenedictElementarySchool: SaintBenedictElementarySchool,
  SaintBrendanSchool: SaintBrendanSchool,
  SaintBridgetSchoolAbington: SaintBridgetSchoolAbington,
  SaintBridgetSchoolFramingham: SaintBridgetSchoolFramingham,
  SaintCatherineofSienaSchool: SaintCatherineofSienaSchool,
  SaintColumbkillePartnership: SaintColumbkillePartnership,
  SaintCharlesElementarySchool: SaintCharlesElementarySchool,
  SaintFrancisXavierSchool: SaintFrancisXavierSchool,
  StJohnsPreparatorySchool: StJohnsPreparatorySchool,
  StJohnPaulCatholicAcademyColumbia: StJohnPaulCatholicAcademyColumbia,
  StJohnPaulCatholicAcademyLowerMills: StJohnPaulCatholicAcademyLowerMills,
  StJohnPaulCatholicAcademyNeponset: StJohnPaulCatholicAcademyNeponset,
  SaintJohntheBaptistSchool: SaintJohntheBaptistSchool,
  SaintJohntheEvangelistSchoolWellesley: SaintJohntheEvangelistSchoolWellesley,
  SaintJohntheEvangelistSchoolDanvers: SaintJohntheEvangelistSchoolDanvers,
  SaintJosephElementarySchoolMedford: SaintJosephElementarySchoolMedford,
  SaintJosephElementarySchoolWakefield: SaintJosephElementarySchoolWakefield,
  StJosephNeedham: StJosephNeedham,
  SaintMaryoftheAnnunciationSchool: SaintMaryoftheAnnunciationSchool,
  SaintMaryoftheAnnunciationSchoolDanvers: SaintMaryoftheAnnunciationSchoolDanvers,
  SaintMaryoftheAnnunciationSchoolMelrose: SaintMaryoftheAnnunciationSchoolMelrose,
  SaintMaryoftheHillsSchool: SaintMaryoftheHillsSchool,
  StMichaelLowell: StMichaelLowell,
  StMichaelNorthAndover: StMichaelNorthAndover,
  SaintMonicaSchool: SaintMonicaSchool,
  SaintPatrickSchoolLowell: SaintPatrickSchoolLowell,
  StPatrickStoneham: StPatrickStoneham,
  SaintPaulSchool: SaintPaulSchool,
  SaintPaulsChoirSchool: SaintPaulsChoirSchool,
  SaintPeterSchool: SaintPeterSchool,
  SaintPiusVElementarySchool: SaintPiusVElementarySchool,
  SaintRaphaelParishSchool: SaintRaphaelParishSchool,
  SaintTheresaCatholicSomerville: SaintTheresaCatholicSomerville,
  SaintTheresaofAvilaWestRoxbury: SaintTheresaofAvilaWestRoxbury,
  SteJeannedArcSchool: SteJeannedArcSchool,
  TheSaintsAcademy: TheSaintsAcademy,
  TrinityCatholicAcademy: TrinityCatholicAcademy,
};

export default images;



// WEBPACK FOOTER //
// ./src/components/SchoolBand/SchoolImages.js